import lodash from 'lodash'

import {
  IOrderEntryBackendCustomer,
  IOrderEntryBackendPreset,
  IOrderEntryCustomer,
  IOrderEntryPreset,
  TOrderEntrySettings,
} from '../types'

function fixPreset(preset: IOrderEntryBackendPreset): IOrderEntryPreset {
  const {
    allowPickupProduct,
    allowDeliveryProduct,
    deliveryAddress,
    defaultCurrency,
    defaultSla,
    defaultSlaId,
    defaultSlaName,
    invoiceAddress,
    pickupAddress,
    allowPickupAddressEdit,
    isPickupAddressStatic,
    skipConfirmation,
    defaultWeight,
    defaultLength,
    defaultWidth,
    defaultHeight,
    allowDeliveryAddressEdit,
    id,
    isDefault,
    isDeliveryAddressStatic,
    name,
    showColis,
    showCustoms,
    showDeliveryAddress,
    showFrankatur,
    showHazmat,
    showInvoiceAddress,
    showMisc,
    showPickupAddress,
    showTransport,
    showUnloadAddress,
    // isPickup,
  } = preset
  const isPickup = !lodash.get(preset, 'isPickupAddressStatic')
  return {
    deliveryAddress,
    defaultCurrency,
    defaultSla,
    defaultSlaId,
    defaultSlaName,
    invoiceAddress,
    pickupAddress,
    allowPickupAddressEdit,
    isPickupAddressStatic,
    skipConfirmation,
    isPickup,
    allowPickupProduct: lodash.isBoolean(allowPickupProduct)
      ? allowPickupProduct
      : isPickup,
    allowDeliveryProduct: lodash.isBoolean(allowDeliveryProduct)
      ? allowDeliveryProduct
      : !isPickup,
    isPickupAndDelivery: allowPickupProduct && allowDeliveryProduct,
    defaultWeight,
    defaultLength,
    defaultWidth,
    defaultHeight,
    allowDeliveryAddressEdit,
    id,
    isDefault,
    isDeliveryAddressStatic,
    name,
    showColis,
    showCustoms,
    showDeliveryAddress,
    showFrankatur,
    showHazmat,
    showInvoiceAddress,
    showMisc,
    showPickupAddress,
    showTransport,
    showUnloadAddress,
    // allowInvoiceAddressEdit,
  }
}

function fixCustomer(
  customer: IOrderEntryBackendCustomer,
): IOrderEntryCustomer {
  const {
    return_address: returnAddresses = [],
    alternate_invoice_adresses: invoiceAddresses = [],
    invoiceaddress: customerInvoiceAddress,
    postaladdress,
    defaultCurrency,
    defaultCountry,
    alternate_sender_addresses: senderAddresses = [],
    importaddress,
    ...rest
  } = customer
  const customerAddress = postaladdress || lodash.first(returnAddresses) // TODO: check which one is preferred
  return {
    ...rest,
    defaultCurrency,
    defaultCountry,
    returnAddresses,
    invoiceAddresses,
    customerInvoiceAddress: customerInvoiceAddress || customerAddress, // TODO: check if this fallback is valid
    customerAddress,
    senderAddresses,
    customerImportAddress: importaddress,
  }
}

export default function fixOrderEntrySettings(
  settings: TOrderEntrySettings,
): TOrderEntrySettings {
  const {
    preset,
    currentCustomer,
    addressbookUrl,
    barcodeUrl,
    customsUrl,
    hazmatUrl,
    id,
    initialValues,
    reusableBoxUrl,
    scrollToTop,
    constantOrderEntryProduct,
    currentPrinter,
    depots,
    isAnonymous,
    isInternal,
    providers,
    requestSubmit,
    externalAddressbook,
    tenantId,
    DebugControls,
    cancelButton,
    isFixed,
    isOrderEditor,
  } = settings

  return {
    addressbookUrl,
    barcodeUrl,
    customsUrl,
    hazmatUrl,
    id,
    initialValues,
    reusableBoxUrl,
    scrollToTop,
    constantOrderEntryProduct,
    currentPrinter,
    depots,
    isAnonymous,
    isInternal,
    providers,
    requestSubmit,
    preset: fixPreset(preset),
    currentCustomer: currentCustomer ? fixCustomer(currentCustomer) : undefined,
    externalAddressbook,
    tenantId,
    DebugControls,
    cancelButton,
    isFixed,
    isOrderEditor,
  }
}
